import Vue from 'vue'
import Vuex from 'vuex'
import gsap from 'gsap'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    codeScreen: 'CodeScreenBase',
    codeScreenProps: {},
    button_vals: ['1', '2', '3', '4', '5', '6', '7', '8', '9'],
    reRender: 0,
    animationPlaying: undefined,
    blockClicks: [],
    showUnlockDialog: false,
    showIntroScreen: true,
    showLevelStartScreen: true,
    levelStartScreenAnimKey: Date.now(),
    level: 0,
    maxLevelAchieved: 0,
    showStageUnlockDialog: false,
    unlockedActions: [[], [], []],
    revealedActions: [[], [], []],
    unlockedHints: [[], [], []],
    unlockProgress: 0,
    stage: 'green',
    stages: ['green', 'red', 'blue'],
    unlockedStages: [],
    creditBalance: 4,
    actions: [
      {
        tripleclick: "Three's a charm",
        slingshot: 'Slingshot',
        spinner: 'Roulette',
        roundtheoutside: 'Long way round',
        sliderotate: 'Twist the dial',
        expand: 'Inflation',
      },
      {
        tripleclick: "Three's a charm",
        slingshot: 'Slingshot',
        spinner: 'Roulette',
        roundtheoutside: 'Long way round',
        sliderotate: 'Twist the dial',
        expand: 'Inflation',
      },
      {
        tripleclick: "Three's a charm",
        slingshot: 'Slingshot',
        spinner: 'Roulette',
        roundtheoutside: 'Long way round',
        sliderotate: 'Twist the dial',
        expand: 'Inflation',
      },
    ],
    hints: [
      {
        tripleclick: 'Tap dance on the ceiling.',
        slingshot: 'Stretch one out to the side.',
        spinner: 'One to spin. One to stop. Wait until it gets lower.',
        roundtheoutside:
          'Leave through the back door and patrol the perimeter.',
        sliderotate:
          'Pick up some friends and take them home the scenic route.',
        expand: 'The bigger the core the better.',
      },
      {
        tripleclick: 'Tap dance on the ceiling.',
        slingshot: 'Stretch one out to the side.',
        spinner: 'One to spin. One to stop. Wait until it gets lower.',
        roundtheoutside:
          'Leave through the back door and patrol the perimeter.',
        sliderotate:
          'Pick up some friends and take them home the scenic route.',
        expand: 'The bigger the core the better.',
      },
      {
        tripleclick: 'Tap dance on the ceiling.',
        slingshot: 'Stretch one out to the side.',
        spinner: 'One to spin. One to stop. Wait until it gets lower.',
        roundtheoutside:
          'Leave through the back door and patrol the perimeter.',
        sliderotate:
          'Pick up some friends and take them home the scenic route.',
        expand: 'The bigger the core the better.',
      },
    ],
    creditCosts: [
      {
        tripleclick: 2,
        slingshot: 1,
        spinner: 2,
        roundtheoutside: 2,
        sliderotate: 2,
        expand: 1,
      },
      {
        tripleclick: 2,
        slingshot: 1,
        spinner: 2,
        roundtheoutside: 2,
        sliderotate: 2,
        expand: 1,
      },
      {
        tripleclick: 2,
        slingshot: 1,
        spinner: 2,
        roundtheoutside: 2,
        sliderotate: 2,
        expand: 1,
      },
    ],
    confimDialog: undefined,
    creditRefreshStart: Date.now(),
    moveNameAnimate: undefined,
    //tutorialStage: 0,
    userWantsTutorial: false,
    mainTutorialSeen: false,
    libraryTutorialSeen: false,
  },
  mutations: {
    SET_BUTTON_VALS(state, vals) {
      Vue.set(state, 'button_vals', vals)
    },
    SET_CODE_SCREEN(state, val) {
      state.codeScreen = val
    },
    SET_CODE_SCREEN_PROPS(state, vals) {
      state.codeScreenProps = vals
    },
    SET_RERENDER_KEY(state, val) {
      state.reRender = val
    },
    SET_BLOCK_CLICKS(state, val) {
      state.blockClicks = val
    },
    SET_SHOW_UNLOCK_DIALOG(state, val) {
      state.showUnlockDialog = val
    },
    SET_SHOW_STAGEUNLOCK_DIALOG(state, val) {
      state.showStageUnlockDialog = val
    },
    SET_SHOW_INTRO_SCREEN(state, val) {
      state.showIntroScreen = val
    },
    SET_UNLOCKED_ACTIONS(state, actions) {
      state.unlockedActions = actions
    },
    SET_UNLOCK_PROGRESS(state, val) {
      state.unlockProgress = val
    },
    TWEEN_UNLOCK_PROGRESS(state, vals) {
      gsap.fromTo(
        state,
        { unlockProgress: vals.from },
        { unlockProgress: vals.to, duration: 0.5 }
      )
    },
    SET_STAGE(state, stage) {
      state.stage = stage
    },
    SET_SHOW_LEVEL_START_SCREEN(state, val) {
      state.showLevelStartScreen = val
    },
    SET_LEVEL_START_ANIM_KEY(state, val) {
      state.levelStartScreenAnimKey = val
    },
    UNLOCK_ACTION(state, action) {
      state.unlockedActions[state.level].push(action)
      state.unlockedActions = [...state.unlockedActions]
    },
    UNLOCK_HINT(state, action) {
      state.unlockedHints[state.level].push(action)
      state.unlockedHints = [...state.unlockedHints]
    },
    REVEAL_ACTION(state, action) {
      state.revealedActions[state.level].push(action)
      state.revealedActions = [...state.revealedActions]
    },
    SET_CONFIRM_DIALOG(state, val) {
      state.confimDialog = val
    },
    UPDATE_CREDIT_BALANCE(state, val) {
      state.creditBalance = val
    },
    SET_LEVEL(state, val) {
      state.level = val
      state.maxLevelAchieved = Math.max(val, state.maxLevelAchieved)
    },
    SET_MOVE_NAME_ANIMATE(state, val) {
      state.moveNameAnimate = val
    },
    /*SET_TUTORIAL_STAGE(state, val) {
      state.tutorialStage = val
    },*/
    SET_USER_WANTS_TUTORIAL(state, val) {
      state.userWantsTutorial = val
    },
    SET_MAIN_TUTORIAL_SEEN(state, val) {
      state.mainTutorialSeen = val
    },
    SET_LIBRARY_TUTORIAL_SEEN(state, val) {
      state.libraryTutorialSeen = val
    },
  },
  actions: {
    rerender({ commit, state }) {
      commit('SET_RERENDER_KEY', state.reRender + 1)
    },
    /*unlock_action({ commit, state, getters }, action) {
      const actionStage = action + '_' + getters.stage
      if (!state.unlockedActions.includes(actionStage)) {
        commit('SET_UNLOCKED_ACTIONS', [...state.unlockedActions, actionStage])
      }
    },*/
    unlock_action({ commit, getters }, action) {
      if (!getters.unlockedActions.includes(action)) {
        commit('UNLOCK_ACTION', action)
      }
    },
    reveal_action({ commit, getters }, action) {
      if (!getters.revealedActions.includes(action)) {
        commit('REVEAL_ACTION', action)
      }
    },
    unlock_stage({ commit, state }, stage) {
      if (!state.unlockedStages.includes(stage)) {
        commit('SET_UNLOCKED_ACTIONS', [...state.unlockedStages, stage])
      }
    },
    unlock_hint({ commit, getters }, actionKey) {
      if (!getters.unlockedHints.includes(actionKey)) {
        commit('UNLOCK_HINT', actionKey)
      }
    },
    play_level_start_anim({ commit }) {
      commit('SET_LEVEL_START_ANIM_KEY', Date.now())
    },
    show_confirmation_dialog({ commit }, vals) {
      commit('SET_CONFIRM_DIALOG', vals)
    },
    clear_confirmation_dialog({ commit }) {
      commit('SET_CONFIRM_DIALOG', undefined)
    },
  },
  getters: {
    button_vals: (state) => state.button_vals,
    codeScreen: (state) => state.codeScreen,
    codeScreenProps: (state) => state.codeScreenProps,
    reRender: (state) => state.reRender,
    isAnimationPlaying: (state) => !(state.animationPlaying === undefined),
    animationPlaying: (state) => state.animationPlaying,
    showUnlockDialog: (state) => state.showUnlockDialog,
    showStageUnlockDialog: (state) => state.showStageUnlockDialog,
    showLevelStartScreen: (state) => state.showLevelStartScreen,
    levelStartAnimKey: (state) => state.levelStartScreenAnimKey,
    level: (state) => state.level,
    maxLevelAchieved: (state) => state.maxLevelAchieved,
    showIntroScreen: (state) => state.showIntroScreen,
    unlockedActions: (state, getters) => state.unlockedActions[getters.level],
    unlockedActionsCount: (state, getters) => getters.unlockedActions.length,
    unlockedHints: (state, getters) => state.unlockedHints[getters.level],
    revealedActions: (state, getters) => state.revealedActions[getters.level],
    hints: (state) => state.hints[state.level],
    isActionUnlocked: (state, getters) => (action) => {
      return getters.unlockedActions.includes(action)
    },
    isActionRevealed: (state, getters) => (action) => {
      return getters.revealedActions.includes(action)
    },
    /*isActionStageUnlocked: (state) => (action) => {
      return state.unlockedActions.includes(action)
    },*/
    lastUnlockedAction: (state, getters) =>
      getters.unlockedActions[getters.unlockedActions.length - 1],
    actions: (state, getters) => state.actions[getters.level],
    //actionsForLevel: (state, getters) => getters.actions[getters.level],
    /*actionNames: () => {
      return {
        tripleclick_green: 'Triple click',
        expand_green: 'Expander',
        slingshot_green: 'Slingshot',
        spinner_green: 'Spin and stop',
        roundtheoutside_green: 'Round the outside',
        sliderotate_green: 'Twist the dial',
      }
    },*/
    /*lastUnlockedActionName: (state, getters) => {
      return getters.actionNames[getters.lastUnlockedAction] || 'As yet unnamed'
    },*/
    blockClicks: (state) => state.blockClicks,
    unlockProgress: (state) => state.unlockProgress,
    stage: (state) => state.stage,
    nextStage: (state) => {
      return state.stages[
        (state.stages.findIndex((x) => x == state.stage) + 1) %
          state.stages.length
      ]
    },
    isStageUnlocked: (state) => (stage) => {
      return state.unlockedStages.includes(stage)
    },
    showConfirmDialog: (state) => !(state.confimDialog === undefined),
    confirmDialogVals: (state) => state.confimDialog,
    creditBalance: (state) => state.creditBalance,
    creditCosts: (state) => state.creditCosts[state.level],
    creditRefreshStart: (state) => state.creditRefreshStart,
    moveNameAnimate: (state) => state.moveNameAnimate,
    //tutorialStage: (state) => state.tutorialStage,
    userWantsTutorial: (state) => state.userWantsTutorial,
    mainTutorialSeen: (state) => state.mainTutorialSeen,
    libraryTutorialSeen: (state) => state.libraryTutorialSeen,
  },
})
